<template>
  <div>
    <a-upload
      v-model="fileList"
      listType="picture-card"
      :fileList="fileList"
      :accept="acceptAttr"
      :disabled="disabled"
      :remove="removeFile"
      :multiple="false"
      :show-upload-list="true"
      :before-upload="beforeUpload"
      :customRequest="customRequest"
      :style="{ height: height + 'px', width: width + 'px' }"
      class="custom-upload"
      @preview="handlePreview">
      <div v-if="1 > fileList.length" class="upload-content">
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div v-show="!loading" class="ant-upload-text">上传</div>
      </div>
    </a-upload>
    <!-- 预览弹窗 -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewCancel" >
      <img v-if="previewFileType === 'img'" alt="example" style="width: 100%" :src="previewImage" />

      <video v-else-if="previewFileType === 'video'" ref="previewVideo" style="width: 100%" controls>
        <source :src="previewImage" type="video/mp4" />
      </video>
      <div v-else>
        文件暂不支持在线预览, 请点击下载至本地后, 进行查看 <br /> <a :href="previewImage"  target="_blank">下载文件</a>
      </div>

    </a-modal>
  </div>
</template>
<script>
import { generateFilePath, uploadObject } from '@/api/tool/oss'

export default {
  props: {
    value: String,
    type: String, // 文件类型, 支持 "img"、"pdf"、"video" 或逗号分隔组合(如 "img,pdf")
    // 最大文件大小, 单位 兆M, 默认 20兆
    maxSize: {
      type: Number,
      default: 20
    },
    /* 文件夹前缀 */
    prefix: {
      type: String,
      default: 'upload'
    },
    // 高度
    height: {
      type: Number,
      default: 100
    },
    // 宽度
    width: {
      type: Number,
      default: 100
    },
    disabled:{
      type: Boolean,
      default: false
    }
  },
  created() {
    this.valueChange(this.value)
  },
  data() {
    return {
      fileList: [], // 文件集合
      loading: false, // 加载状态
      previewVisible: false, // 预览弹窗隐藏/显示
      previewImage: '', // 预览文件 url
      previewFileType: '' // 当前预览文件类型: img/video/pdf/other
    }
  },
  computed: {
    acceptAttr() {
      const acceptMap = {
        img: 'image/*',
        pdf: '.pdf',
        video: 'video/mp4'
      }
      const accepts = this.getAllowedTypeTokens().map(token => acceptMap[token]).filter(Boolean)
      return accepts.length ? accepts.join(',') : undefined
    }
  },
  methods: {
    // 删除图片
    removeFile(file) {
      this.fileList = this.fileList.filter(item => item.url !== file.url)
      const val = this.fileList.map(item => item.url).join(',')
      this.$emit('input', val)
      this.$emit('change', val)
    },
    // 预览按钮点击
    handlePreview(file) {
      this.previewImage = file.url
      this.previewFileType = this.resolvePreviewType(file)
      if (this.previewFileType === 'pdf') {
        window.open(this.previewImage, '_blank')
        this.previewVisible = false
        return
      }
      this.previewVisible = true
    },
    // 上传之前校验
    beforeUpload(file) {
      const allowTypeTokens = this.getAllowedTypeTokens()
      if (allowTypeTokens.length > 0) {
        const isAllowedType = allowTypeTokens.some(token => this.isFileTypeMatch(file, token))
        if (!isAllowedType) {
          this.$message.error(`上传文件类型不支持，请上传 ${this.type} 类型文件`)
          return false
        }
      }
      // 大小校验
      if (file.size / 1024 / 1024 > this.maxSize) {
        this.$message.error(`上传文件大小不能超过 ${this.maxSize} MB`)
        return false
      }
    },
    // 解析允许上传的类型，支持以逗号分隔传入多个类型
    getAllowedTypeTokens() {
      if (!this.type) return []
      return this.type.split(',').map(item => item.trim().toLowerCase()).filter(Boolean).map(item => {
        if (item === 'image') return 'img'
        if (item === 'mp4') return 'video'
        return item
      })
    },
    // 判断文件是否匹配目标类型
    isFileTypeMatch(file, typeToken) {
      const fileMime = (file.type || '').toLowerCase()
      const fileName = (file.name || '').toLowerCase()
      const ext = this.getFileExtension(fileName)
      if (typeToken === 'img') {
        return fileMime.startsWith('image/') || ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.svg'].includes(ext)
      }
      if (typeToken === 'pdf') {
        return fileMime === 'application/pdf' || ext === '.pdf'
      }
      if (typeToken === 'video') {
        return fileMime === 'video/mp4' || ext === '.mp4'
      }
      return false
    },
    getFileExtension(fileName = '') {
      const idx = fileName.lastIndexOf('.')
      return idx >= 0 ? fileName.substring(idx) : ''
    },
    resolvePreviewType(file) {
      const fileMime = ((file && file.type) || '').toLowerCase()
      const url = ((file && file.url) || '').toLowerCase()
      const ext = this.getFileExtension(url)
      if (fileMime.startsWith('image/') || ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.svg'].includes(ext)) {
        return 'img'
      }
      if (fileMime === 'video/mp4' || ext === '.mp4') {
        return 'video'
      }
      if (fileMime === 'application/pdf' || ext === '.pdf') {
        return 'pdf'
      }
      return 'other'
    },
    // 自定义上传请求
    customRequest(fileInfo, index) {
      this.loading = true

      // 文件
      const uploadFile = fileInfo.file

      // 文件夹目录
      const prefix = this.prefix
      const url = this.buildOssUrl(uploadFile.name, prefix)

      // oss 上传
      uploadObject(url, uploadFile).then(res => {
        this.fileList.push(this.createAntFileObj(res))
        this.$message.success('上传成功')
        this.loading = false
        const val = this.fileList.map(item => item.url).join(',')
        this.$emit('input', val)
        this.$emit('change', val)
      })
    },
    // 构建 oss url
    buildOssUrl(fileName, prefix) {
      // 获取文件后缀
      const suffix = fileName.substring(fileName.lastIndexOf('.'))
      // 生成文件名称
      const filePath = generateFilePath(prefix, suffix)
      return filePath
    },
    // 文件随机 uid
    getUidRandom() {
      return Math.round(Math.random() * 80 + 20)
    },
    // 预览关闭
    previewCancel() {
      this.previewVisible = false
      // 视频暂停播放
      if (this.$refs.previewVideo) {
        this.$refs.previewVideo.pause()
      }
    },
    /*valueChange(newValue) {
      if (!newValue) {
        this.fileList = []
        return
      }
      if (typeof newValue === 'string') {
        const imgUrls = newValue.split(',')
        // 判断 url 是否存在, 不存在进行添加
        imgUrls.forEach(imgUrl => {
          for (let i = 0; i < this.fileList.length; i++) {
            const item = this.fileList[i]
            if (item.url === imgUrl) {
              return
            }
          }
          this.fileList.push(this.createAntFileObj(imgUrl))
        })
      } else {
        this.fileList = newValue.map(item => (this.createAntFileObj(item)))
      }
    },*/
    valueChange(newValue) {
      if (!newValue) {
        this.fileList = []
        return
      }
      if (typeof newValue === 'string') {
        const imgUrls = newValue.split(',').map(s => s.trim()).filter(Boolean)
        // 与父组件 v-model 同步时必须整表替换，否则会保留旧 url，出现多张缩略图（如规格图更新后 SKU 仍叠加上一值）
        this.fileList = [this.createAntFileObj(newValue)]
      } else {
        this.fileList = newValue.map(item => (this.createAntFileObj(item)))
      }
    },
    // 创建 ant fileList 的对象
    createAntFileObj(ossUrl) {
      return {
        status: 'done',
        url: ossUrl,
        uid: this.getUidRandom(),
        name: ossUrl,
        thumbUrl: this.getThumbUrl(ossUrl)
      }
    },
    // 预览图片
    getThumbUrl(ossUrl) {
      const previewType = this.resolvePreviewType({ url: ossUrl })
      if (previewType === 'video') {
        // 视频, 使用 oss 封面图功能, 文档: https://help.aliyun.com/zh/oss/user-guide/video-snapshots
        return ossUrl + '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast'
      }
      if (previewType === 'pdf') {
        return this.getPdfThumbUrl()
      }
      // 图片/默认
      return ossUrl
    },
    // PDF 使用默认缩略图，避免直接使用 pdf 链接导致缩略图加载失败
    getPdfThumbUrl() {
      return 'data:image/svg+xml;utf8,' + encodeURIComponent(
        "<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'>" +
          "<rect x='14' y='8' width='92' height='104' rx='8' fill='#fff' stroke='#d9d9d9' stroke-width='2'/>" +
          "<path d='M78 8v24h28' fill='#fff'/>" +
          "<path d='M78 8l28 24H78z' fill='#ffd8d8'/>" +
          "<rect x='28' y='52' width='64' height='26' rx='4' fill='#ff4d4f'/>" +
          "<text x='60' y='70' text-anchor='middle' font-size='14' font-family='Arial, sans-serif' fill='#fff'>PDF</text>" +
        '</svg>'
      )
    },
    // 下载文件
    downloadFile() {
      const link = document.createElement('a')
      link.href = this.previewImage
      link.download = this.previewImage.split('/').pop() || 'download'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  watch: {
    // 监听上级 value 改变
    value(newValue) {
      this.valueChange(newValue)
    },
    // Watch for height/width changes
    height(newValue) {
      this.$el.style.setProperty('--upload-height', newValue + 'px');
    },
    width(newValue) {
      this.$el.style.setProperty('--upload-width', newValue + 'px');
    }
  },
  mounted() {
    // Set CSS variables for dimensions
    this.$el.style.setProperty('--upload-height', this.height + 'px');
    this.$el.style.setProperty('--upload-width', this.width + 'px');
  }
}
</script>
<style scoped>
.custom-upload :deep(.ant-upload.ant-upload-select-picture-card) {
  height: var(--upload-height);
  width: var(--upload-width);
}

.custom-upload :deep(.ant-upload-list-picture-card .ant-upload-list-item) {
  padding: 0;
  height: var(--upload-height);
  width: var(--upload-width);
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
